
class portSetUpCtrl {
    constructor($scope, httpRequest, $state, logger, sweetalert) {
        $scope.params = {
            pageNum: 1,
            pageSize: 10,
            param: {
                interfaceName: '',
                interfaceType: '',
            },
        }
        $scope.reset = function () {
            $scope.params.param = {
                interfaceName: '',
                interfaceType: '',
            }
        }
        // $scope.reset()
        $scope.tableDropdownConfig = [
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确定删除？').then(() => {
                        httpRequest.get_delSysInterface(item.interfaceId).then(() => {
                            logger.logSuccess('删除成功')
                            $scope.queryList()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('delete_port')
                },
            }, {
                label: '编辑',
                handler(item) {
                    $state.go('system.settingcenter.portSetUp.edit', {
                        interfaceId: item.interfaceId,
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('edit_port')
                },

            }, {
                label: '查看',
                handler(item) {
                    $state.go('system.settingcenter.portSetUp.detail', {
                        interfaceId: item.interfaceId,
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('view_port')
                },

            },
        ]

        httpRequest.get_dictByTypeArr(['system_module']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.queryList = function queryList() {
            httpRequest.post_getSysInterfaceList($scope.params).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        $scope.queryList()
        $scope.add = function add() {
            $state.go('system.settingcenter.portSetUp.add')
        }
    }
}

portSetUpCtrl.$inject = ['$scope', 'httpRequest', '$state', 'logger', 'sweetalert']
export default portSetUpCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/portSetUp/portSetUpCtrl.js